import { cn } from '~/chords/lib/cn';

export const OVERLAY_CLASS = {
  show: cn('animate-dialog-overlay-show'),
  hide: cn('animate-dialog-overlay-hide'),
} as const;

/**
 * Array of individually wrapped Tailwind utility classes because
 * they're applied using `classList.add()` and `classList.remove()`
 */
export const CONTENT_CLASS = {
  show: [cn('translate-x-0'), cn('ease-out')],
  hide: [cn('!pointer-events-none'), cn('ease-in')],
} as const;

export const SIDE_CLASS = {
  right: cn('right-0 border-l border-l-emphasis-subtle'),
  left: cn('left-0 border-r border-r-emphasis-subtle'),
} as const;
